const MatchesTypes = {
    GET_MATCHES_START:'GET_MATCHES_START',
    GET_MATCHES_SUCCESS:'GET_MATCHES_SUCCESS',
    GET_MATCHES_FAILED:'GET_MATCHES_FAILED',

}

export default MatchesTypes